import { Lender } from '@/models/bank-models.model';
import { NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonModule } from 'primeng/button';

@Component({
    selector: 'app-lender-card',
    imports: [
      NgIf,
      ButtonModule
    ],
    template: `
    <div class="mb-0 h-full" *ngIf="lender">
    <div class="p-3 border-round shadow-2 flex align-items-center card h-full" 
         [class.cursor-pointer]="selectable"
         [class.hover:bg-gray-50]="selectable"
         [class.hover:shadow-3]="selectable"
         [class.transition-all]="selectable"
         [class.duration-200]="selectable"
         (click)="onSelectLender()">
        <div *ngIf="!isGeneric(lender)" style="width:48px;height:48px;flex-shrink:0;" class="bg-teal-100 inline-flex align-items-center justify-content-center">
            <img class="block xl:block mx-auto rounded-md w-full h-full object-cover" [src]="'https://spexisstorage.blob.core.windows.net/bank-logos/' + lender.LenderID + '.png'" [alt]="lender.LenderID" />
        </div>
                 <div *ngIf="isGeneric(lender)" style="width:48px;height:48px;flex-shrink:0;" class="bg-teal-100 rounded-md flex align-items-center justify-content-center icon-container">
            <i class="pi pi-building-columns text-teal-600" style="font-size: 2.5rem"></i>
        </div>
        <div class="ml-2">
            <span class="text-900 text-xl font-medium mb-2">{{ lender.Title }}</span>
            <p class="mt-1 mb-0 text-600 font-medium text-sm">{{ getSubtitle(lender) }}</p>
        </div>
</div>
</div>
    `,
     styles: `
     .icon-container {
       display: flex;
       align-items: center;
       justify-content: center;
     }
     
     .pi.pi-file {
       display: flex;
       align-items: center;
       justify-content: center;
       line-height: 1;
     }
   `
})
export class LenderCardComponent {
  @Input() lender: Lender | undefined | null;
  @Output() selectLender = new EventEmitter<Lender>();
  @Input() selectable: boolean = true;
  generics = [100,133]

  isGeneric(lender: Lender) {
    return this.generics.includes(lender.LenderID);
  }

  getSubtitle(lender: Lender) {
    if (lender.LenderContacts && lender.LenderContacts.length === 1) {
      if (lender.LenderContacts[0].contactFirstName && lender.LenderContacts[0].contactLastName) {
      return lender.LenderContacts[0].contactFirstName + ' ' + lender.LenderContacts[0].contactLastName;
    } else { return '1 contact'} 
  }

    return `${lender.LenderContacts?.length || 0} contacts`;
  }

  onSelectLender() {
    if (this.selectable) {
      if (this.lender) {
        this.selectLender.emit(this.lender);
      }
    }
  }

}
